import * as React from 'react';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';
import { Panel } from '@ixicare/ui';
import ResidentFormContainer from '~/containers/Residents/ResidentForm';

const ResidentFormCreatePage = () => {
  usePageTitle(t('residents.create.title'));
  return (
    <Panel>
      <ResidentFormContainer profile={null} />
    </Panel>
  );
};

export default ResidentFormCreatePage;
